import React, { Component } from "react";
import _ from "lodash";

export interface InputProps {
    field?: any;
    form?: any;
    inputtype?: string;
    placeholder?: string;
    givenid?: string;
    disabled?: boolean;
    decimal?: boolean;
    isConfig?: boolean;
    items?: { value: any; description: any; country: any; company: any; id: any }[];
}

export interface InputState {
    values?: any;
}


export default class BaseInputAlias extends Component<InputProps, InputState> {

    constructor(props) {
        super(props);
        this.state = {
                values: _.cloneDeep(this.props.field.value)
            }
    }

    setFieldTouched = () => {
        const { field } = this.props;
        let { touched } = this.props.form;
        touched[field.name] = true;
        this.props.form.setTouched(touched);
    }

    updateFormValue = (newValue) => {
        this.props.form.setFieldValue(this.props.field.name, newValue);
    }

    changeValue = (value, country, company, subsidiary) => {
        this.setFieldTouched();
        const addValue = {
            country: country,
            company: company,
            subsidiary: subsidiary,
            value: value
        }
        let newValue = [...this.state.values];
        newValue.find(v => v.subsidiary==subsidiary && v.country==country && v.company==company) ? newValue.map(v => { if(v.subsidiary==subsidiary && v.country==country && v.company==company) v.value=value}) : newValue.push(addValue)
        this.updateFormValue(_.cloneDeep(newValue));
        this.setState({
            values: newValue
        });
    }

    render() {
        const fieldName = this.props.field.name;
        const errors =
            this.props.form.errors[fieldName] != "Field is required."
            || (this.props.isConfig && !this.props.disabled)
                ? this.props.form.errors[fieldName]
                : this.props.form.touched[fieldName] &&
                this.props.form.errors[fieldName];

        const errorMessageEl = errors && (
            <div className="input-error">
                {Array.isArray(errors) && errors.map((error, index) => {
                    if (typeof error === 'object') {
                        return Object.keys(error).map((objKey, objIndex) => {
                            return <span key={`${index}-${objIndex}`} className="input-error-message">{error[objKey]}</span>
                        })
                    } else {
                        return <span key={`${index}-single`} className="input-error-message">{error}</span>
                    }
                })}
                {!Array.isArray(errors) && (<span className="input-error-message">{errors}</span>)}
            </div>
        );

        const props = { ...this.props };
        delete props.decimal;

        const fieldProps = { ...this.props.field };
        delete fieldProps.value;

        return (
            <div id={this.props.givenid + "Input"}>
                <div
                    className={
                        "array-input input-group "
                    }
                >
                    <div
                        style={{ padding: "0px 16px 3px 16px", height: "auto", width: "auto", border: "none" }}
                        className="input"
                    >
                        <table className="array-table" cellSpacing="0" cellPadding="0">
                            <tbody>
                                {this.props.items.map((item_value, item_index) => {
                                    let defaultValue = this.state.values.find(v => v.subsidiary && v.subsidiary==item_value.id && v.country && v.country==item_value.country.id && v.company && v.company==item_value.company.id)
                                    if(defaultValue) defaultValue = defaultValue.value
                                    else defaultValue = ''
                                    return (
                                        <tr key={'tr'+item_index}>
                                            <td>
                                                {item_value.description}
                                            </td>
                                            <td>
                                                <input
                                                    defaultValue={defaultValue}
                                                    key={`value_${item_value.description}`}
                                                    type="input"
                                                    onChange={(event) => this.changeValue(event.currentTarget.value, item_value.country.id, item_value.company.id, item_value.id)}
                                                    placeholder="Alias"
                                                />
                                            </td>
                                        </tr>
                                    )
                                })}

                            </tbody>
                        </table>
                    </div>
                </div>
                {errorMessageEl}
            </div>
        );
    }
}
